<template>
  <v-card>
    <v-toolbar card color="white">
      <type-events-filters @search="localPagination.page = 1" />
      <v-text-field
        v-model="search"
        :placeholder="$t('action.buttons.search')"
        flat
        hide-details
        prepend-icon="search"
        solo
      />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :items="filteredList"
        :headers="headers"
        :expand="expand"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        :search="search"
        disable-initial-sort
        item-key="_id"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="!existsTypeEvent(props.item._id)"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.icon" alt />
            </v-avatar>
          </td>
          <td style="min-width: 300px">
            <template v-for="(oneType, index) in props.item.type">
              <v-chip :key="index + oneType" small color="primary" dark>
                {{ $t(`fields.events.types.${oneType}`) }}
              </v-chip>
            </template>
          </td>
          <td>
            {{
              props.item.group
                ? $t(`fields.events.groups.${props.item.group}`)
                : '--'
            }}
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.vote" />
          </td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-clone
      :dialog.sync="dialogClone"
      :loading="loading"
      @clone="setClone(idClone)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import TypeEventsFilters from './TypeEventsFilters'
import DialogClone from '@/components/widgets/dialog/DialogClone'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'TypeEventList',
  components: {
    DialogDelete,
    DialogClone,
    DialogUpdatedRecord,
    TypeEventsFilters,
  },
  data() {
    return {
      search: '',
      expand: false,
      idDelete: '',
      idClone: '',
      dialogDelete: false,
      dialogClone: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    // search (val) {
    //   if (this.localPagination.page !== 1) this.localPagination.page = 1
    //   else this.debounceFetch()
    // },
    // 'localPagination.page': {
    //   handler: function (val, oldVal) {
    //     this.fetchList({ match: this.search })
    //   }
    // }
  },
  mounted() {
    this.fetchListConst()
  },
  computed: {
    ...mapState({
      loading: (state) => state.typeEvents.loading,
      selected: (state) => state.typeEvents.selected,
      pagination: (state) => state.typeEvents.pagination,
      filters: (state) => state.typeEvents.filters,
      typeEventsConst: (state) => state.typeEvents.typeEventsConst,
    }),
    ...mapGetters({
      formatedList: 'typeEvents/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$t('fields.global.icon'),
          align: 'center',
          value: 'icon',
        },
        {
          text: this.$t('fields.global.type'),
          value: 'type',
        },
        {
          text: this.$tc('models.group'),
          value: 'group',
        },
        {
          text: this.$t('fields.events.vote'),
          align: 'center',
          value: 'vote',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          align: 'center',
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    filteredList() {
      return this.formatedList.filter((item) => {
        let isValid = true
        if (this.filters.type && this.filters.type.length) {
          isValid = this.filters.type.some((type) => item.type.includes(type))
        }
        if (this.filters.group) {
          isValid = isValid && item.group == this.filters.group
        }

        return isValid
      })
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('typeEvents/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'typeEvents/fetchOne',
      setCreate: 'typeEvents/create',
      setDelete: 'typeEvents/delete',
      reset: 'typeEvents/reset',
      fetchList: 'typeEvents/fetchList',
      fetchListConst: 'typeEvents/fetchListConst',
    }),
    existsTypeEvent(idTypeEvent) {
      return Object.values(this.typeEventsConst).includes(idTypeEvent)
    },
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    setNew() {
      this.$emit('clear')
      this.$emit('form')
    },
    openUpdated(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifClone(id) {
      this.idClone = id
      this.dialogClone = true
    },
    setClone(id) {
      this.fetchOne(id).then((typeEvent) => {
        let payload = parseObject(typeEvent)
        delete payload._id
        payload.name.forEach((item) => (item.text += ' (copy)'))
        this.setCreate(payload).then(() => (this.dialogClone = false))
      })
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      this.fetchList({
        match: this.search,
      })
    }, 1000),
  },
}
</script>
